export default __webpack_public_path__ + "static/media/oksana.fcb3602d.jpg";